<app-menu></app-menu>

<section class="controltask-page" *ngIf="tenantId; else emptyState">
  <div class="controltask-shell">
    <aside class="task-nav">
      <div class="nav-header">
        <div>
          <p>{{ 'CONTROLTASK.PERSONAL_VIEW' | translate }}</p>
          <h2>{{ 'CONTROLTASK.TITLE' | translate }}</h2>
        </div>
      </div>

      <div class="nav-section">
        <p class="nav-label">{{ 'CONTROLTASK.SHORTCUTS' | translate }}</p>
        <button type="button" class="nav-item" [class.active]="listFilter === 'today'" (click)="selectTodayTasks()">
          <div class="item-info">
            <mat-icon>wb_sunny</mat-icon>
            <span>{{ 'CONTROLTASK.TODAY' | translate }}</span>
          </div>
          <strong>{{ todayTasksCount }}</strong>
        </button>
        <button type="button" class="nav-item" [class.active]="listFilter === 'important'" (click)="selectQuickFilter('important')">
          <div class="item-info">
            <mat-icon>star_rate</mat-icon>
            <span>{{ 'CONTROLTASK.IMPORTANT' | translate }}</span>
          </div>
          <strong>{{ importantTasksCount }}</strong>
        </button>
        <button type="button" class="nav-item" [class.active]="listFilter === 'all' && !selectedGroupId" (click)="selectQuickFilter('all')">
          <div class="item-info">
            <mat-icon>fact_check</mat-icon>
            <span>{{ 'CONTROLTASK.MY_TASKS' | translate }}</span>
          </div>
          <strong>{{ activeFilteredTasks.length }}</strong>
        </button>
      </div>

      <div class="nav-section group-section">
        <p class="nav-label">{{ 'CONTROLTASK.GROUPS' | translate }}</p>
        <div
          class="group-list"
          [class.scrollable]="groups.length >= 6"
          [style.maxHeight.px]="groups.length >= 6 ? 320 : null"
          *ngIf="groups.length">
          <div class="group-block" *ngFor="let group of groups">
            <div class="group-label" (click)="toggleGroup(group.id)">
              <div class="item-info stacked">
                <mat-icon>group_work</mat-icon>
                <div>
                  <strong>{{ group.name }}</strong>
                </div>
              </div>
              <div class="group-meta">
                <strong>{{ subgroupCount(group.id) }}</strong>
                <mat-icon class="chevron" [class.open]="isGroupOpen(group.id)">expand_more</mat-icon>
              </div>
            </div>
            <ul class="subgroup-list" *ngIf="isGroupOpen(group.id) && subgroupsForGroup(group.id).length">
              <li *ngFor="let subgroup of subgroupsForGroup(group.id)"
                  [class.active]="selectedSubgroupId === subgroup.id"
                  (click)="selectGroup(group.id, subgroup.id)">
                <span class="subgroup-meta">
                  <span class="dot" [style.background]="subgroup.color || '#b2c0d4'"></span>
                  <span class="subgroup-name">{{ subgroup.name }}</span>
                </span>
                <span class="subgroup-count">{{ subgroupTaskCount(subgroup.id) }}</span>
              </li>
            </ul>
          </div>
        </div>
        <ng-container *ngIf="groupsLoaded && !groups.length">
          <p class="empty-hint">{{ 'CONTROLTASK.NO_GROUPS' | translate }}</p>
          <button class="btn ghost full" (click)="openGroupModal()">{{ 'CONTROLTASK.CREATE_GROUP' | translate }}</button>
        </ng-container>
      </div>
    </aside>

    <main class="task-list-area">
      <header class="list-toolbar">
        <div>
          <h1>{{ currentListLabel }}</h1>
          <p>{{ 'CONTROLTASK.TASKS_LISTED' | translate:{ count: activeFilteredTasks.length } }}</p>
        </div>
        <div class="toolbar-actions">
          <div class="action-icons">
            <div class="icon-wrapper">
              <button class="icon-btn" (click)="toggleGroupMenu($event)" [title]="'CONTROLTASK.GROUP_ACTIONS' | translate">
                <mat-icon>groups</mat-icon>
              </button>
              <div class="action-menu" *ngIf="showGroupActions">
                <button type="button" (click)="openGroupModal()">{{ 'CONTROLTASK.ADD_GROUP' | translate }}</button>
                <button type="button" (click)="openStandaloneSubgroupModal()">{{ 'CONTROLTASK.ADD_SUBGROUP' | translate }}</button>
                <button type="button" (click)="openStandaloneBucketModal()">{{ 'CONTROLTASK.ADD_BUCKET' | translate }}</button>
              </div>
            </div>
            <div class="icon-wrapper">
              <button class="icon-btn" (click)="toggleTaskMenu($event)" [title]="'CONTROLTASK.TASK_ACTIONS' | translate">
                <mat-icon>playlist_add</mat-icon>
              </button>
              <div class="action-menu" *ngIf="showTaskActions">
                <button type="button" (click)="openTaskFromMenu()">{{ 'CONTROLTASK.ADD_TASK' | translate }}</button>
              </div>
            </div>
            <div class="icon-wrapper">
              <button class="icon-btn filter-btn" (click)="toggleFilterPanel()" [title]="'CONTROLTASK.FILTERS' | translate">
                <mat-icon>filter_list</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </header>

      <div class="list-filters">
        <div class="filter-search">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            [placeholder]="'CONTROLTASK.SEARCH_TASK' | translate"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            [ngModelOptions]="{ standalone: true }"
            name="task-search">
        </div>
      </div>
      <div class="filter-summary" *ngIf="hasActiveFilters">
        <div class="filter-summary-info">
          <mat-icon>filter_alt</mat-icon>
          <span>{{ 'CONTROLTASK.FILTERS_APPLIED' | translate }}</span>
        </div>
        <div class="filter-summary-tags">
          <span class="filter-tag" *ngFor="let label of activeFilterLabels">{{ label }}</span>
        </div>
        <button type="button" class="btn ghost slim" (click)="clearAllFilters()">{{ 'CONTROLTASK.CLEAR_FILTERS' | translate }}</button>
      </div>

      <div class="filter-panel-overlay" *ngIf="showFilterPanel" (click)="closeFilterPanel()"></div>
      <aside class="filter-panel" [class.open]="showFilterPanel">
        <header>
          <h3>{{ 'CONTROLTASK.FILTERS' | translate }}</h3>
          <button type="button" class="icon-btn" (click)="closeFilterPanel()" [title]="'COMMON.CLOSE' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </header>
        <div class="filter-panel-body">
          <label>{{ 'CONTROLTASK.STATUS_LABEL' | translate }}
            <select [(ngModel)]="statusFilter" (change)="loadTasks()">
              <option value="ALL">{{ 'CONTROLTASK.STATUS.ALL' | translate }}</option>
              <option value="OPEN">{{ 'CONTROLTASK.STATUS.OPEN' | translate }}</option>
              <option value="IN_PROGRESS">{{ 'CONTROLTASK.STATUS.IN_PROGRESS' | translate }}</option>
              <option value="PAUSED">{{ 'CONTROLTASK.STATUS.PAUSED' | translate }}</option>
              <option value="BLOCKED">{{ 'CONTROLTASK.STATUS.BLOCKED' | translate }}</option>
              <option value="COMPLETED">{{ 'CONTROLTASK.STATUS.COMPLETED' | translate }}</option>
              <option value="AWAITING_CLIENT_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_CLIENT_RESPONSE' | translate }}</option>
              <option value="AWAITING_BUDGET_APPROVAL">{{ 'CONTROLTASK.STATUS.AWAITING_BUDGET_APPROVAL' | translate }}</option>
              <option value="AWAITING_SUPPLIER_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_SUPPLIER_RESPONSE' | translate }}</option>
            </select>
          </label>
          <label>{{ 'CONTROLTASK.GROUP_LABEL' | translate }}
            <select
              [(ngModel)]="filterGroupId"
              (ngModelChange)="onFilterGroupChange($event)"
              [ngModelOptions]="{ standalone: true }">
              <option value="">{{ 'CONTROLTASK.ALL' | translate }}</option>
              <option *ngFor="let group of groups" [ngValue]="group.id">{{ group.name }}</option>
            </select>
          </label>
          <label>{{ 'CONTROLTASK.BUCKET_LABEL' | translate }}
            <select
              [(ngModel)]="filterBucketId"
              (ngModelChange)="onFilterBucketChange($event)"
              [disabled]="!bucketFilterOptions.length"
              [ngModelOptions]="{ standalone: true }">
              <option value="">{{ 'CONTROLTASK.ALL' | translate }}</option>
              <option *ngFor="let bucket of bucketFilterOptions" [ngValue]="bucket.id">{{ bucket.name }}</option>
            </select>
          </label>
          <button class="pill" *ngIf="selectedGroupId || filterGroupId" (click)="clearGroupFilter()">{{ 'CONTROLTASK.CLEAR_GROUP_FILTER' | translate }}</button>
          <button class="pill" (click)="clearAllFilters()">{{ 'CONTROLTASK.CLEAR_FILTERS' | translate }}</button>
        </div>
      </aside>

      <section class="task-list" [class.loading]="loading">
        <header class="task-list-head">
          <span class="col-code">{{ 'CONTROLTASK.TABLE.CODE' | translate }}</span>
          <span class="col-task">{{ 'CONTROLTASK.TABLE.TASK' | translate }}</span>
          <span class="col-bucket">{{ 'CONTROLTASK.TABLE.BUCKET' | translate }}</span>
          <span class="col-date">{{ 'CONTROLTASK.TABLE.START' | translate }}</span>
          <span class="col-updated">{{ 'CONTROLTASK.TABLE.LAST_UPDATE' | translate }}</span>
          <span class="col-execution">{{ 'CONTROLTASK.TABLE.EXECUTION' | translate }}</span>
          <span class="col-status">{{ 'CONTROLTASK.TABLE.STATUS' | translate }}</span>
        </header>

        <article class="task-row" *ngFor="let task of paginatedActiveTasks; trackBy: trackByTask" (click)="openTaskDetail(task)">
          <div class="row-code">#{{ task.task_code || '------' }}</div>
          <div class="row-task">
            <div class="row-text">
              <p class="title">
                {{ task.title }}
              </p>
              <span class="group-trail">{{ formatGroupTrail(task) }}</span>
            </div>
          </div>
          <div class="row-bucket">{{ bucketName(task) }}</div>
          <div class="row-date">{{ formatDate(task.start_date) }}</div>
          <div class="row-updated">{{ latestCommentDate(task) }}</div>
          <div class="row-execution" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="execution-toggle"
              [class.on]="isTaskExecuting(task)"
              [disabled]="!canToggleTaskExecution(task)"
              (click)="toggleTaskExecution(task, !isTaskExecuting(task))">
              <span class="execution-toggle__track">
                <span class="execution-toggle__thumb"></span>
              </span>
              <span class="execution-toggle__meta">
                <strong>{{ taskExecutionStateLabel(task) }}</strong>
                <small>{{ taskExecutionLabel(task) }}</small>
              </span>
            </button>
          </div>
          <div class="row-status">
            <span class="status-pill" [ngClass]="statusClass(task.status)">{{ translateStatus(task.status) }}</span>
          </div>
        </article>
        <p class="empty" *ngIf="!loading && !paginatedActiveTasks.length">{{ 'CONTROLTASK.EMPTY_ACTIVE' | translate }}</p>
      </section>

      <div class="pagination-bar" *ngIf="activeFilteredTasks.length > pageSize">
        <button class="btn ghost" (click)="goToPage('prev')" [disabled]="currentPage === 1">{{ 'PAGINATION.PREV' | translate }}</button>
        <span>{{ 'PAGINATION.PAGE_OF' | translate:{ page: currentPage, total: activeTotalPages } }}</span>
        <button class="btn ghost" (click)="goToPage('next')" [disabled]="currentPage === activeTotalPages">{{ 'PAGINATION.NEXT' | translate }}</button>
      </div>

      <section class="task-list completed" *ngIf="completedFilteredTasks.length">
        <header class="task-list-toggle" (click)="toggleCompletedExpanded()">
          <div class="toggle-title">
            <mat-icon>{{ completedExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            <span>{{ 'CONTROLTASK.COMPLETED.TITLE' | translate }}</span>
            <small>{{ 'CONTROLTASK.COMPLETED.COUNT' | translate:{ count: completedFilteredTasks.length } }}</small>
          </div>
          <button type="button" class="btn ghost" (click)="toggleCompletedExpanded(); $event.stopPropagation()">
            {{ completedExpanded ? ('CONTROLTASK.COLLAPSE' | translate) : ('CONTROLTASK.EXPAND' | translate) }}
          </button>
        </header>

        <ng-container *ngIf="completedExpanded">
          <div class="task-list-head">
            <span class="col-code">{{ 'CONTROLTASK.TABLE.CODE' | translate }}</span>
            <span class="col-task">{{ 'CONTROLTASK.TABLE.COMPLETED' | translate }}</span>
            <span class="col-bucket">{{ 'CONTROLTASK.TABLE.BUCKET' | translate }}</span>
            <span class="col-date">{{ 'CONTROLTASK.TABLE.START' | translate }}</span>
            <span class="col-updated">{{ 'CONTROLTASK.TABLE.LAST_UPDATE' | translate }}</span>
            <span class="col-execution">{{ 'CONTROLTASK.TABLE.EXECUTION' | translate }}</span>
            <span class="col-status">{{ 'CONTROLTASK.TABLE.STATUS' | translate }}</span>
          </div>
          <article class="task-row" *ngFor="let task of paginatedCompletedTasks" (click)="openTaskDetail(task)">
            <div class="row-code">#{{ task.task_code || '------' }}</div>
            <div class="row-task">
              <div class="row-text">
                <p class="title">
                  {{ task.title }}
                </p>
                <span class="group-trail">{{ formatGroupTrail(task) }}</span>
              </div>
            </div>
            <div class="row-bucket">{{ bucketName(task) }}</div>
            <div class="row-date">{{ formatDate(task.start_date) }}</div>
            <div class="row-updated">{{ latestCommentDate(task) }}</div>
            <div class="row-execution" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="execution-toggle"
              [class.on]="isTaskExecuting(task)"
              [disabled]="!canToggleTaskExecution(task)"
              (click)="toggleTaskExecution(task, !isTaskExecuting(task))">
                <span class="execution-toggle__track">
                  <span class="execution-toggle__thumb"></span>
                </span>
                <span class="execution-toggle__meta">
                  <strong>{{ taskExecutionStateLabel(task) }}</strong>
                  <small>{{ taskExecutionLabel(task) }}</small>
                </span>
              </button>
            </div>
            <div class="row-status">
              <span class="status-pill completed">{{ 'CONTROLTASK.STATUS.COMPLETED' | translate }}</span>
            </div>
          </article>
          <p class="empty" *ngIf="!paginatedCompletedTasks.length">{{ 'CONTROLTASK.COMPLETED.EMPTY' | translate }}</p>
          <div class="pagination-bar" *ngIf="completedFilteredTasks.length > pageSize">
            <button class="btn ghost" (click)="goToCompletedPage('prev')" [disabled]="completedPage === 1">{{ 'PAGINATION.PREV' | translate }}</button>
            <span>{{ 'PAGINATION.PAGE_OF' | translate:{ page: completedPage, total: completedTotalPages } }}</span>
            <button class="btn ghost" (click)="goToCompletedPage('next')" [disabled]="completedPage === completedTotalPages">{{ 'PAGINATION.NEXT' | translate }}</button>
          </div>
        </ng-container>
      </section>
    </main>
  </div>
</section>

<ng-template #emptyState>
  <section class="empty-state">
    <p>{{ 'CONTROLTASK.EMPTY_LOGIN' | translate }}</p>
  </section>
</ng-template>

<!-- Modal Nova Tarefa -->
<div class="modal-backdrop" *ngIf="showTaskModal">
  <div class="modal-card task-modal">
    <header>
      <h2>{{ 'CONTROLTASK.MODAL.NEW_TASK' | translate }}</h2>
      <button class="icon" (click)="closeTaskModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="taskForm" (ngSubmit)="submitTask()">
      <div class="task-detail-grid">
        <div class="task-main">
          <label>{{ 'CONTROLTASK.FIELD.TITLE' | translate }}
            <input formControlName="title" type="text" [placeholder]="'CONTROLTASK.PLACEHOLDER.TASK_SUMMARY' | translate">
          </label>

          <label>{{ 'CONTROLTASK.FIELD.DESCRIPTION' | translate }}
            <textarea formControlName="description" rows="3" [placeholder]="'CONTROLTASK.PLACEHOLDER.TASK_DETAILS' | translate"></textarea>
          </label>

          <div class="form-grid">
            <label>{{ 'CONTROLTASK.FIELD.STATUS' | translate }}
              <select formControlName="status">
                <option value="OPEN">{{ 'CONTROLTASK.STATUS.OPEN' | translate }}</option>
                <option value="IN_PROGRESS">{{ 'CONTROLTASK.STATUS.IN_PROGRESS' | translate }}</option>
                <option value="PAUSED">{{ 'CONTROLTASK.STATUS.PAUSED' | translate }}</option>
                <option value="BLOCKED">{{ 'CONTROLTASK.STATUS.BLOCKED' | translate }}</option>
                <option value="COMPLETED">{{ 'CONTROLTASK.STATUS.COMPLETED' | translate }}</option>
                <option value="AWAITING_CLIENT_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_CLIENT_RESPONSE' | translate }}</option>
                <option value="AWAITING_BUDGET_APPROVAL">{{ 'CONTROLTASK.STATUS.AWAITING_BUDGET_APPROVAL' | translate }}</option>
                <option value="AWAITING_SUPPLIER_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_SUPPLIER_RESPONSE' | translate }}</option>
              </select>
            </label>
            <label>{{ 'CONTROLTASK.FIELD.VISIBILITY' | translate }}
              <select formControlName="visibility">
                <option value="PRIVATE">{{ 'CONTROLTASK.VISIBILITY.PRIVATE' | translate }}</option>
                <option value="PUBLIC">{{ 'CONTROLTASK.VISIBILITY.PUBLIC' | translate }}</option>
              </select>
            </label>
            <label>{{ 'CONTROLTASK.FIELD.PRIORITY' | translate }}
              <select formControlName="priority">
                <option value="LOW">{{ 'CONTROLTASK.PRIORITY.LOW' | translate }}</option>
                <option value="MEDIUM">{{ 'CONTROLTASK.PRIORITY.MEDIUM' | translate }}</option>
                <option value="HIGH">{{ 'CONTROLTASK.PRIORITY.HIGH' | translate }}</option>
                <option value="URGENT">{{ 'CONTROLTASK.PRIORITY.URGENT' | translate }}</option>
              </select>
            </label>
          </div>

          <div class="form-grid">
            <label>{{ 'CONTROLTASK.FIELD.START' | translate }}
              <input type="date" formControlName="start_date">
            </label>
            <label>{{ 'CONTROLTASK.FIELD.DUE' | translate }}
              <input type="date" formControlName="due_date">
            </label>
          </div>

          <label>{{ 'CONTROLTASK.FIELD.GROUP' | translate }}
            <select formControlName="groupId" (change)="handleGroupSelectionChange()">
              <option value="">{{ 'COMMON.SELECT' | translate }}</option>
              <option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</option>
            </select>
          </label>

          <label *ngIf="availableFormSubgroups.length">{{ 'CONTROLTASK.FIELD.SUBGROUP' | translate }}
            <select formControlName="subgroupId" (change)="handleSubgroupSelectionChange()">
              <option value="">{{ 'COMMON.SELECT' | translate }}</option>
              <option *ngFor="let subgroup of availableFormSubgroups" [value]="subgroup.id">{{ subgroup.name }}</option>
            </select>
          </label>

          <div class="bucket-field">
            <label>{{ 'CONTROLTASK.FIELD.BUCKET' | translate }}
              <select formControlName="bucketId" [disabled]="!availableFormBuckets.length">
                <option value="">{{ 'COMMON.SELECT' | translate }}</option>
                <option *ngFor="let bucket of availableFormBuckets" [value]="bucket.id">{{ bucket.name }}</option>
              </select>
            </label>
            <p class="inline-hint" *ngIf="!taskForm.get('subgroupId')?.value">
              {{ 'CONTROLTASK.HINT.SELECT_SUBGROUP' | translate }}
            </p>
            <div class="inline-bucket-form" *ngIf="taskForm.get('subgroupId')?.value && !availableFormBuckets.length">
              <p class="inline-hint">{{ 'CONTROLTASK.HINT.NO_BUCKETS' | translate }}</p>
              <label>{{ 'CONTROLTASK.FIELD.NEW_BUCKET_NAME' | translate }}
                <input type="text" formControlName="inlineBucketName" [placeholder]="'CONTROLTASK.PLACEHOLDER.BUCKET_NAME' | translate">
              </label>
              <label>{{ 'CONTROLTASK.FIELD.NEW_BUCKET_DESC' | translate }}
                <input type="text" formControlName="inlineBucketDescription" [placeholder]="'CONTROLTASK.PLACEHOLDER.BUCKET_DESC' | translate">
              </label>
              <button type="button"
                      class="btn slim"
                      (click)="createInlineBucket()"
                      [disabled]="inlineBucketLoading || !taskForm.get('inlineBucketName')?.value?.trim()">
                {{ inlineBucketLoading ? ('CONTROLTASK.SAVING' | translate) : ('CONTROLTASK.ACTION.CREATE_BUCKET' | translate) }}
              </button>
            </div>
          </div>

          <label>{{ 'CONTROLTASK.FIELD.TAGS' | translate }}
            <select formControlName="tagIds" multiple>
              <option *ngFor="let tag of tags" [value]="tag.id">{{ tag.name }}</option>
            </select>
          </label>

          <label>{{ 'CONTROLTASK.FIELD.ASSIGNEE' | translate }}
            <select formControlName="assigneeId">
              <option value="">{{ 'COMMON.SELECT' | translate }}</option>
              <option *ngFor="let member of members" [value]="member.id">{{ member.name }}</option>
            </select>
          </label>

          <div class="subtask-creator">
            <label>{{ 'CONTROLTASK.FIELD.SUBTASKS' | translate }}
              <div class="subtask-input-row">
                <input type="text" formControlName="newSubtask" [placeholder]="'CONTROLTASK.PLACEHOLDER.SUBTASK' | translate">
                <button type="button" (click)="addDraftSubtask()">{{ 'CONTROLTASK.ACTION.ADD' | translate }}</button>
              </div>
            </label>
            <ul *ngIf="draftSubtasks.length">
              <li *ngFor="let subtask of draftSubtasks; let i = index">
                {{ subtask }}
                <button type="button" (click)="removeDraftSubtask(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </li>
            </ul>
          </div>

          <div class="task-attachments">
            <label>{{ 'CONTROLTASK.FIELD.ATTACHMENTS' | translate }}</label>
            <div class="attachment-actions">
              <button type="button" class="btn ghost" (click)="taskAttachmentInput.click()">{{ 'CONTROLTASK.ACTION.ADD_ATTACHMENTS' | translate }}</button>
              <input
                type="file"
                #taskAttachmentInput
                class="hidden-input"
                (change)="onTaskFilesSelected($event)"
                multiple>
            </div>
            <ul class="file-list" *ngIf="newTaskFiles.length">
              <li class="file-item" *ngFor="let file of newTaskFiles; let i = index">
                <span>{{ file.name }}</span>
                <button type="button" (click)="removeTaskFile(i)">{{ 'CONTROLTASK.ACTION.REMOVE' | translate }}</button>
              </li>
            </ul>
          </div>
        </div>
        <aside class="task-side-panel">
          <h4>{{ 'CONTROLTASK.SIDEPANEL.TITLE' | translate }}</h4>
          <p>{{ 'CONTROLTASK.SIDEPANEL.SUBTITLE' | translate }}</p>
          <ul>
            <li><span>{{ 'CONTROLTASK.FIELD.SUBTASKS' | translate }}</span><strong>{{ draftSubtasks.length }}</strong></li>
            <li><span>{{ 'CONTROLTASK.FIELD.GROUP' | translate }}</span><strong>{{ taskForm.value.groupId ? 1 : 0 }}</strong></li>
            <li><span>{{ 'CONTROLTASK.FIELD.TAGS' | translate }}</span><strong>{{ taskForm.value.tagIds?.length || 0 }}</strong></li>
          </ul>
        </aside>
      </div>

      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="closeTaskModal()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="submit" class="btn primary" [disabled]="taskForm.invalid">{{ 'CONTROLTASK.ACTION.CREATE_TASK' | translate }}</button>
      </footer>
    </form>
  </div>
</div>

<!-- Modal Detalhe da Tarefa -->
<div class="modal-backdrop" *ngIf="showTaskDetailModal && activeTask">
  <div class="modal-card detail-modal">
    <header>
      <h2>{{ 'CONTROLTASK.DETAIL.TITLE' | translate }} <small *ngIf="activeTask">#{{ activeTask.task_code || '------' }}</small></h2>
      <button class="icon" (click)="closeTaskDetail()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="taskDetailForm" (ngSubmit)="submitTaskDetail()">
      <div class="detail-body">
        <div class="detail-grid">
          <section class="detail-main">
            <label>{{ 'CONTROLTASK.FIELD.TITLE' | translate }}
              <input type="text" formControlName="title">
            </label>
            <div class="rich-text">
              <textarea
                rows="5"
                formControlName="description"
                [placeholder]="'CONTROLTASK.PLACEHOLDER.DETAIL_CONTEXT' | translate"></textarea>
            </div>

            <section class="detail-card detail-subtasks">
              <header>
                <div class="subtask-header">
                  <div class="subtask-title" *ngIf="activeTask">
                    <h4>{{ 'CONTROLTASK.FIELD.SUBTASKS' | translate }}</h4>
                    <small>
                      {{ completedSubtasks(activeTask) }}/{{ (activeTask.subtasks || []).length }} {{ 'CONTROLTASK.DETAIL.SUBTASKS_DONE' | translate }} •
                      {{ subtaskProgress(activeTask) | number:'1.0-0' }}%
                    </small>
                  </div>
                  <div class="subtask-progress" *ngIf="activeTask">
                    <div class="progress-bar">
                      <div class="progress" [style.width.%]="subtaskProgress(activeTask)"></div>
                    </div>
                  </div>
                </div>
              </header>
              <div class="subtask-input-row">
                <input
                  type="text"
                  [(ngModel)]="detailSubtaskText"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'CONTROLTASK.PLACEHOLDER.ADD_SUBTASK' | translate"
                  name="detail-subtask">
                <button type="button" (click)="addDetailSubtask()">{{ 'CONTROLTASK.ACTION.ADD' | translate }}</button>
              </div>
              <div
                class="subtask-list"
                *ngIf="activeTask?.subtasks?.length"
                cdkDropList
                [cdkDropListData]="activeTask.subtasks"
                (cdkDropListDropped)="reorderDetailSubtasks($event)">
                <div class="subtask-item" *ngFor="let subtask of activeTask?.subtasks" cdkDrag>
                  <label class="subtask-toggle">
                    <input type="checkbox" [checked]="!!subtask.completed" (change)="toggleDetailSubtask(subtask)">
                    <span class="toggle-visual"></span>
                  </label>
                  <button type="button" class="drag-handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </button>
                  <div class="subtask-info">
                    <p class="title" *ngIf="editingSubtaskId !== subtask.id">{{ subtask.title }}</p>
                    <input
                      *ngIf="editingSubtaskId === subtask.id"
                      class="subtask-edit-input"
                      type="text"
                      [(ngModel)]="editingSubtaskText"
                      [ngModelOptions]="{ standalone: true }">
                    <p class="meta" *ngIf="subtask.due_date; else noSubtaskDate">
                      {{ 'CONTROLTASK.FIELD.DUE' | translate }} {{ subtask.due_date | date:'dd/MM' }}
                    </p>
                    <ng-template #noSubtaskDate>
                      <p class="meta muted">{{ 'CONTROLTASK.NO_DATE_DEFINED' | translate }}</p>
                    </ng-template>
                  </div>
                  <button type="button" class="calendar-chip" (click)="openSubtaskDatePicker(datePicker)">
                    <mat-icon>event</mat-icon>
                    <span>
                      {{ subtask.due_date ? (subtask.due_date | date:'dd/MM') : ('CONTROLTASK.ACTION.SET_DATE' | translate) }}
                    </span>
                  </button>
                  <input
                    #datePicker
                    type="date"
                    class="subtask-date-input"
                    [value]="subtask.due_date ? toInputDate(subtask.due_date) : ''"
                    (click)="$event.stopPropagation()"
                    (change)="updateSubtaskDueDate(subtask, $event)">
                  <div class="subtask-actions">
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId !== subtask.id"
                      (click)="startEditSubtask(subtask)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId === subtask.id"
                      (click)="saveEditSubtask(subtask)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingSubtaskId === subtask.id"
                      (click)="cancelEditSubtask()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button type="button" class="icon-btn danger" (click)="deleteSubtask(subtask)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-card comments-section">
              <header>
                <h4>{{ 'CONTROLTASK.DETAIL.COMMENTS' | translate }}</h4>
              </header>
              <textarea
                rows="3"
                class="comment-input"
                [(ngModel)]="detailCommentText"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="'CONTROLTASK.PLACEHOLDER.COMMENT' | translate"></textarea>
              <div class="comment-tools">
                <div class="file-chip" *ngIf="detailCommentFile">
                  <mat-icon>attach_file</mat-icon>
                  <span>{{ detailCommentFile.name }}</span>
                  <button type="button" class="icon" (click)="removeCommentFile()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
              <div class="comment-actions">
                <button type="button" class="file-btn" (click)="commentFileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                  {{ 'CONTROLTASK.ACTION.ATTACH' | translate }}
                </button>
                <input
                  type="file"
                  #commentFileInput
                  class="hidden-input"
                  (change)="onCommentFileSelected($event)">
                <button
                  type="button"
                  class="btn ghost"
                  (click)="addDetailComment()"
                  [disabled]="!(detailCommentText.trim() || detailCommentFile)">
                  {{ 'CONTROLTASK.ACTION.SEND' | translate }}
                </button>
              </div>
              <ul class="comment-list" *ngIf="activeTask?.comments?.length; else noComments">
                <li *ngFor="let comment of activeTask?.comments">
                  <div class="comment-header">
                    <strong>{{ comment.author || comment.author_name || ('CONTROLTASK.DETAIL.CONTRIBUTOR' | translate) }}</strong>
                    <span>{{ comment.created_at | date:'short' }}</span>
                  </div>
                  <p class="comment-text" *ngIf="editingCommentId !== comment.id">{{ comment.text || comment.comment }}</p>
                  <textarea
                    *ngIf="editingCommentId === comment.id"
                    class="comment-edit-input"
                    rows="3"
                    [(ngModel)]="editingCommentText"
                    [ngModelOptions]="{ standalone: true }"></textarea>
                  <div class="comment-actions-row">
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId !== comment.id"
                      (click)="startEditComment(comment)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId === comment.id"
                      (click)="saveEditComment(comment)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="icon-btn"
                      *ngIf="editingCommentId === comment.id"
                      (click)="cancelEditComment()">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button type="button" class="icon-btn danger" (click)="deleteComment(comment)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <div class="comment-attachment" *ngIf="comment.attachments?.length || comment.file_path">
                    <div class="comment-attachment-item" *ngFor="let file of comment.attachments">
                      <a
                        [href]="formatCommentFile(file.file_path)"
                        target="_blank"
                        rel="noopener">
                        <mat-icon>attach_file</mat-icon>
                        <span>{{ file.file_name || ('CONTROLTASK.ACTION.VIEW_FILE' | translate) }}</span>
                      </a>
                      <button type="button" class="icon-btn danger" (click)="removeCommentAttachment(comment, file)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <a
                      *ngIf="!comment.attachments?.length && comment.file_path"
                      [href]="formatCommentFile(comment.file_path)"
                      target="_blank"
                      rel="noopener">
                      <mat-icon>attach_file</mat-icon>
                      <span>{{ comment.file_name || ('CONTROLTASK.ACTION.VIEW_FILE' | translate) }}</span>
                    </a>
                  </div>
                </li>
              </ul>
              <ng-template #noComments>
                <p class="empty-hint">{{ 'CONTROLTASK.DETAIL.NO_COMMENTS' | translate }}</p>
              </ng-template>
            </section>

            <section class="detail-card task-attachments-section">
              <header>
                <h4>{{ 'CONTROLTASK.FIELD.ATTACHMENTS' | translate }}</h4>
              </header>
              <div class="attachment-list" *ngIf="activeTask?.attachments?.length; else noTaskAttachments">
                <div *ngFor="let file of activeTask?.attachments">
                  <a [href]="taskAttachmentUrl(file)" target="_blank" rel="noopener">
                    <mat-icon>attach_file</mat-icon>
                    <span>{{ file.file_name || ('CONTROLTASK.ACTION.VIEW_FILE' | translate) }}</span>
                  </a>
                  <small>{{ file.uploaded_at | date:'short' }}</small>
                </div>
              </div>
              <ng-template #noTaskAttachments>
                <p class="empty-hint">{{ 'CONTROLTASK.DETAIL.NO_ATTACHMENTS' | translate }}</p>
              </ng-template>
            </section>

          </section>
          <aside class="detail-side">
            <div class="config-card">
              <label>{{ 'CONTROLTASK.FIELD.STATUS' | translate }}
                <select formControlName="status">
                <option value="OPEN">{{ 'CONTROLTASK.STATUS.OPEN' | translate }}</option>
                <option value="IN_PROGRESS">{{ 'CONTROLTASK.STATUS.IN_PROGRESS' | translate }}</option>
                <option value="PAUSED">{{ 'CONTROLTASK.STATUS.PAUSED' | translate }}</option>
                <option value="BLOCKED">{{ 'CONTROLTASK.STATUS.BLOCKED' | translate }}</option>
                <option value="COMPLETED">{{ 'CONTROLTASK.STATUS.COMPLETED' | translate }}</option>
                <option value="AWAITING_CLIENT_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_CLIENT_RESPONSE' | translate }}</option>
                <option value="AWAITING_BUDGET_APPROVAL">{{ 'CONTROLTASK.STATUS.AWAITING_BUDGET_APPROVAL' | translate }}</option>
                <option value="AWAITING_SUPPLIER_RESPONSE">{{ 'CONTROLTASK.STATUS.AWAITING_SUPPLIER_RESPONSE' | translate }}</option>
                </select>
              </label>
              <label>{{ 'CONTROLTASK.FIELD.PRIORITY' | translate }}
                <select formControlName="priority">
                  <option value="LOW">{{ 'CONTROLTASK.PRIORITY.LOW' | translate }}</option>
                  <option value="MEDIUM">{{ 'CONTROLTASK.PRIORITY.MEDIUM' | translate }}</option>
                  <option value="HIGH">{{ 'CONTROLTASK.PRIORITY.HIGH' | translate }}</option>
                  <option value="URGENT">{{ 'CONTROLTASK.PRIORITY.URGENT' | translate }}</option>
                </select>
              </label>
              <label>{{ 'CONTROLTASK.FIELD.VISIBILITY' | translate }}
                <select formControlName="visibility">
                  <option value="PRIVATE">{{ 'CONTROLTASK.VISIBILITY.PRIVATE' | translate }}</option>
                  <option value="PUBLIC">{{ 'CONTROLTASK.VISIBILITY.PUBLIC' | translate }}</option>
                </select>
              </label>
              <label>{{ 'CONTROLTASK.FIELD.START' | translate }}
                <input type="date" formControlName="start_date">
              </label>
              <label>{{ 'CONTROLTASK.FIELD.END' | translate }}
                <input type="date" formControlName="due_date">
              </label>
            </div>

            <div class="config-card">
              <label>{{ 'CONTROLTASK.FIELD.GROUP' | translate }}
                <select formControlName="groupId" (change)="handleDetailGroupChange()">
                  <option value="">{{ 'COMMON.SELECT' | translate }}</option>
                  <option *ngFor="let group of groups" [ngValue]="group.id">{{ group.name }}</option>
                </select>
              </label>
              <label *ngIf="detailFormSubgroups.length">{{ 'CONTROLTASK.FIELD.SUBGROUP' | translate }}
                <select formControlName="subgroupId" (change)="handleDetailSubgroupChange()">
                  <option value="">{{ 'COMMON.SELECT' | translate }}</option>
                  <option *ngFor="let subgroup of detailFormSubgroups" [ngValue]="subgroup.id">{{ subgroup.name }}</option>
                </select>
              </label>
              <label *ngIf="detailFormBuckets.length">{{ 'CONTROLTASK.FIELD.BUCKET' | translate }}
                <select formControlName="bucketId">
                  <option value="">{{ 'COMMON.SELECT' | translate }}</option>
                  <option *ngFor="let bucket of detailFormBuckets" [ngValue]="bucket.id">{{ bucket.name }}</option>
                </select>
              </label>
            </div>

            <div class="config-card">
              <label>{{ 'CONTROLTASK.FIELD.ASSIGNEE' | translate }}
                <select formControlName="assigneeId">
                  <option value="">{{ 'COMMON.SELECT' | translate }}</option>
                  <option *ngFor="let member of members" [ngValue]="member.id">{{ member.name }}</option>
                </select>
              </label>
              <label>{{ 'CONTROLTASK.FIELD.TAGS' | translate }}
                <select formControlName="tagIds" multiple>
                  <option *ngFor="let tag of tags" [ngValue]="tag.id">{{ tag.name }}</option>
                </select>
              </label>
            </div>
          </aside>
        </div>
      </div>
      <footer class="modal-actions">
        <button type="button" class="btn ghost danger" (click)="deleteTask(activeTask)">{{ 'CONTROLTASK.ACTION.DELETE_TASK' | translate }}</button>
        <button type="button" class="btn ghost" (click)="closeTaskDetail()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="submit" class="btn primary" [disabled]="taskDetailForm.invalid">{{ 'CONTROLTASK.ACTION.SAVE_CHANGES' | translate }}</button>
      </footer>
    </form>
  </div>
</div>

<!-- Modal Grupos -->
<div class="modal-backdrop" *ngIf="showGroupModal">
  <div class="modal-card small">
    <header>
      <h2>{{ 'CONTROLTASK.GROUP.NEW_TITLE' | translate }}</h2>
      <button class="icon" (click)="showGroupModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="groupForm" (ngSubmit)="submitGroup()">
      <label>{{ 'CONTROLTASK.FIELD.NAME' | translate }}
        <input formControlName="name" type="text" [placeholder]="'CONTROLTASK.PLACEHOLDER.GROUP_NAME' | translate">
      </label>
      <label>{{ 'CONTROLTASK.FIELD.DESCRIPTION' | translate }}
        <textarea formControlName="description" rows="3" [placeholder]="'CONTROLTASK.PLACEHOLDER.GROUP_DESC' | translate"></textarea>
      </label>
      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="showGroupModal = false">{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn primary" type="submit" [disabled]="groupForm.invalid">{{ 'CONTROLTASK.GROUP.CREATE' | translate }}</button>
      </footer>
    </form>
  </div>
</div>

<!-- Modal Subgrupo -->
<div class="modal-backdrop" *ngIf="showSubgroupModal">
  <div class="modal-card small">
    <header>
      <h2>{{ 'CONTROLTASK.SUBGROUP.NEW_TITLE' | translate }}</h2>
      <button class="icon" (click)="showSubgroupModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="subgroupForm" (ngSubmit)="submitSubgroup()">
      <label>{{ 'CONTROLTASK.FIELD.GROUP' | translate }}
        <select formControlName="group_id">
          <option value="">{{ 'COMMON.SELECT' | translate }}</option>
          <option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</option>
        </select>
      </label>
      <label>{{ 'CONTROLTASK.FIELD.NAME' | translate }}
        <input formControlName="name" type="text" [placeholder]="'CONTROLTASK.PLACEHOLDER.SUBGROUP_NAME' | translate">
      </label>
      <label>{{ 'CONTROLTASK.FIELD.DESCRIPTION' | translate }}
        <textarea formControlName="description" rows="3" [placeholder]="'CONTROLTASK.PLACEHOLDER.SUBGROUP_DESC' | translate"></textarea>
      </label>
      <label>{{ 'CONTROLTASK.FIELD.COLOR' | translate }}
        <input formControlName="color" type="text" placeholder="#009688">
      </label>
      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="showSubgroupModal = false">{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn primary" type="submit" [disabled]="subgroupForm.invalid">{{ 'CONTROLTASK.SUBGROUP.CREATE' | translate }}</button>
      </footer>
    </form>
  </div>
</div>

<!-- Modal Bucket -->
<div class="modal-backdrop" *ngIf="showBucketModal">
  <div class="modal-card small">
    <header>
      <h2>{{ 'CONTROLTASK.BUCKET.NEW_TITLE' | translate }}</h2>
      <button class="icon" (click)="showBucketModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="bucketForm" (ngSubmit)="submitBucket()">
      <label>{{ 'CONTROLTASK.FIELD.GROUP' | translate }}
        <select formControlName="group_id" (change)="onBucketGroupChange()">
          <option value="">{{ 'COMMON.SELECT' | translate }}</option>
          <option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</option>
        </select>
      </label>
      <label>{{ 'CONTROLTASK.FIELD.SUBGROUP' | translate }}
        <select formControlName="subgroup_id" [disabled]="!bucketFormSubgroups.length">
          <option value="">{{ 'COMMON.SELECT' | translate }}</option>
          <option *ngFor="let subgroup of bucketFormSubgroups" [value]="subgroup.id">{{ subgroup.name }}</option>
        </select>
      </label>
      <label>{{ 'CONTROLTASK.FIELD.NAME' | translate }}
        <input formControlName="name" type="text" [placeholder]="'CONTROLTASK.PLACEHOLDER.BUCKET_TITLE' | translate">
      </label>
      <label>{{ 'CONTROLTASK.FIELD.DESCRIPTION' | translate }}
        <textarea formControlName="description" rows="3"></textarea>
      </label>
      <div class="form-grid">
        <label>{{ 'CONTROLTASK.FIELD.ORDER' | translate }}
          <input type="number" min="0" formControlName="order_index">
        </label>
        <label>{{ 'CONTROLTASK.FIELD.COLOR' | translate }}
          <input formControlName="color" type="text" placeholder="#4dd0e1">
        </label>
      </div>
      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="showBucketModal = false">{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn primary" type="submit" [disabled]="bucketForm.invalid">{{ 'CONTROLTASK.BUCKET.SAVE' | translate }}</button>
      </footer>
    </form>
  </div>
</div>

<!-- Modal Tags -->
<div class="modal-backdrop" *ngIf="showTagModal">
  <div class="modal-card small">
    <header>
      <h2>{{ 'CONTROLTASK.TAG.NEW_TITLE' | translate }}</h2>
      <button class="icon" (click)="showTagModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form [formGroup]="tagForm" (ngSubmit)="submitTag()">
      <label>{{ 'CONTROLTASK.FIELD.NAME' | translate }}
        <input formControlName="name" type="text" [placeholder]="'CONTROLTASK.PLACEHOLDER.TAG_NAME' | translate">
      </label>
      <label>{{ 'CONTROLTASK.FIELD.COLOR' | translate }}
        <input formControlName="color" type="text" placeholder="#00BFA5">
      </label>
      <footer class="modal-actions">
        <button type="button" class="btn ghost" (click)="showTagModal = false">{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn primary" type="submit" [disabled]="tagForm.invalid">{{ 'CONTROLTASK.TAG.CREATE' | translate }}</button>
      </footer>
    </form>
  </div>
</div>
